<template>
  <div class="control-currency-number d-flex align-items-center">
    <button
      class="decrement-button"
      :disabled="decrementDisabled"
      @click="decrement"
    >
      <img src="../assets/images/chevron-left.svg" />
    </button>
    <div class="number-box">
      <div class="number-value">
        {{
          currentValue
            | currency({
              symbol: "€",
              thousandsSeparator: ".",
              fractionCount: 0,
              fractionSeparator: ",",
              symbolPosition: "",
              symbolSpacing: true
            })
        }}
      </div>
      <div class="number-description">{{ description }}</div>
    </div>
    <button
      class="increment-button"
      :disabled="incrementDisabled"
      @click="increment"
    >
      <img src="../assets/images/chevron-right.svg" />
    </button>
  </div>
</template>

<script>
export default {
  name: "CurrencySpinner",
  value: "",
  props: {
    disabled: Boolean,
    description: String,
    value: {
      required: true
    },
    listValues: Array,
    maxValue: Number
  },

  data() {
    return {
      currentValue: this.value,
      decrementDisabled: false,
      incrementDisabled: false,
      inputDisabled: false
    };
  },
  watch: {
    value(val) {
      this.currentValue = val;
      this.incrementDisabled =
        val === this.listValues[this.listValues.length - 1];
      this.decrementDisabled = val === this.listValues[0];
    }
  },

  methods: {
    increment() {
      if (this.disabled || this.incrementDisabled) {
        return;
      }
      const newIndex = 1 + this.listValues.indexOf(this.currentValue);
      if (newIndex >= this.listValues.length) {
        return;
      }
      let newVal = this.listValues[newIndex];
      if (newVal > this.maxValue) {
        return;
      }

      this._updateValue(newVal);
    },
    decrement() {
      if (this.disabled || this.decrementDisabled) {
        return;
      }
      const newIndex = this.listValues.indexOf(this.currentValue) - 1;
      if (newIndex < 0) {
        return;
      }
      let newVal = this.listValues[newIndex];

      this._updateValue(newVal);
    },
    _updateValue(newVal) {
      const oldVal = this.currentValue;

      if (oldVal === newVal || typeof this.value !== "number") {
        return;
      }
      this.incrementDisabled =
        newVal === this.listValues[this.listValues.length - 1];
      this.decrementDisabled = newVal === this.listValues[0];

      this.currentValue = newVal;
      this.$emit("input", this.currentValue);
    }
  },

  mounted() {
    if (
      typeof this.currentValue === "undefined" ||
      this.currentValue === null ||
      this.currentValue === 0
    ) {
      this.currentValue = this.listValues[0];
    }
    if (this.currentValue == this.listValues[0]) {
      this.decrementDisabled = true;
    }
    if (this.currentValue == this.listValues[this.listValues.length - 1]) {
      this.incrementDisabled = true;
    }
  }
};
</script>

<style></style>
